import { TPacketList, useGetLoraPackets } from 'api/packets/getLoraPacketList'
import { useTranslation } from 'react-i18next'
import { RiRedPacketLine } from 'react-icons/ri'
import { useParams } from 'react-router-dom'
import { LoraPacketTable } from 'views/panel/Packets/LoraPacketList/components/LoraPacketTable'
import { QueryPaginated } from '..'

export const LoraGatewayPacketList = () => {
  const { t } = useTranslation()
  const { deviceId } = useParams()
  const query = useGetLoraPackets({ gatewayId: deviceId })

  return (
    <>
      <QueryPaginated.Wrapper query={query}>
        <QueryPaginated.Data>
          {(data: TPacketList) => <LoraPacketTable data={data.items} />}
        </QueryPaginated.Data>
        <QueryPaginated.NoData
          icon={RiRedPacketLine}
          title={t('packet.noData')}
        />
      </QueryPaginated.Wrapper>
    </>
  )
}
